import ErrorSubclass from 'util/ErrorSubclass';

export default class BenchlingTypeDeserializationException extends ErrorSubclass {}
